import { Container, Typography, Grid } from '@mui/material'
import type React from 'react'

import AccountSettings from '@/components/settings/AccountSettings'
import AppBarPageContainer from '@/components/UI/PageContainer'
import Tabs from '@/components/UI/Tabs'
import useTab from '@/hooks/useTab'
import useUser from '@/hooks/useUser'
import type { UserData } from '@/types/User'

import AddDemoApplicantTab from './AddDemoApplicantTab'

interface Props {
  collapsedMenu: boolean
  userData: UserData
  onChangeCustomerId: (customerId: string) => void
}

const gridSpacing = 4

const tabs = ['company', 'setupDemoApplicant'] as const

type Tab = (typeof tabs)[number]

const isDemoCustomer = (customerId?: string): boolean =>
  customerId !== undefined &&
  [
    '69126d8a-4ec0-47b8-948c-55af9f3919de',
    'c07a02c0-c32d-4b41-8eb6-32c09b0c2d03',
  ].includes(customerId)

const SettingsPage: React.FC<Props> = ({
  collapsedMenu,
  userData,
  onChangeCustomerId,
}) => {
  const { customerId } = useUser()

  const { selectedTab, handleChangeTab } = useTab<Tab>({
    availableTabs: tabs,
    defaultTab: 'company',
  })

  if (!userData) return <div>Loading...</div>
  return (
    <AppBarPageContainer
      isNavigationDrawerOpen={!collapsedMenu}
      headerAppBarContent={
        <Typography component="h1" variant="h6">
          Settings
        </Typography>
      }
      pageContent={
        <>
          <Container maxWidth="xl">
            <Grid container paddingBottom={gridSpacing} spacing={gridSpacing}>
              <Grid item xs={12}>
                <Tabs
                  value={selectedTab}
                  onChange={handleChangeTab}
                  config={[
                    {
                      label: 'Company',
                      value: 'company',
                    },
                    ...(isDemoCustomer(customerId)
                      ? [
                          {
                            label: 'Setup a demo',
                            value: 'setupDemoApplicant' as Tab,
                          },
                        ]
                      : []),
                  ]}
                />
              </Grid>
              {selectedTab === 'company' && (
                <AccountSettings
                  userData={userData}
                  onChangeCustomerId={onChangeCustomerId}
                />
              )}
              {selectedTab === 'setupDemoApplicant' && <AddDemoApplicantTab />}
            </Grid>
          </Container>
        </>
      }
    />
  )
}

export default SettingsPage
